export const RESET_ERROR = 'statuses/RESET_ERROR';

export const FETCH_STATUS_REFERENCE = 'statuses/FETCH_STATUS_REFERENCE';
export const FETCH_STATUS_REFERENCE_FAIL = 'statuses/FETCH_STATUS_REFERENCE_FAIL';
export const FETCH_STATUS_REFERENCE_SUCCESS = 'statuses/FETCH_STATUS_REFERENCE_SUCCESS';
export const CREATE_STATUS_REFERENCE_SUCCESS = 'statuses/CREATE_STATUS_REFERENCE_SUCCESS';
export const CREATE_STATUS_REFERENCE_FAIL = 'statuses/CREATE_STATUS_REFERENCE_FAIL';
export const UPDATE_STATUS_REFERENCE_SUCCESS = 'statuses/UPDATE_STATUS_REFERENCE_SUCCESS';
export const UPDATE_STATUS_REFERENCE_FAIL = 'statuses/UPDATE_STATUS_REFERENCE_FAIL';
export const DELETE_STATUS_REFERENCE_SUCCESS = 'statuses/DELETE_STATUS_REFERENCE_SUCCESS';
export const DELETE_STATUS_REFERENCE_FAIL = 'statuses/DELETE_STATUS_REFERENCE_FAIL';
export const SET_PRIMARY_STATUS_REFERENCE_SUCCESS = 'statuses/SET_PRIMARY_STATUS_REFERENCE_SUCCESS';
export const SET_PRIMARY_STATUS_REFERENCE_FAIL = 'statuses/SET_PRIMARY_STATUS_REFERENCE_FAIL';
export const CLEAR_STATUS_REFERENCE = 'statuses/CLEAR_STATUS_REFERENCE';
